import { render, staticRenderFns } from "./VideoPostPublish.vue?vue&type=template&id=d4d07ab8&scoped=true"
import script from "./VideoPostPublish.vue?vue&type=script&lang=js"
export * from "./VideoPostPublish.vue?vue&type=script&lang=js"
import style0 from "./VideoPostPublish.vue?vue&type=style&index=0&id=d4d07ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d07ab8",
  null
  
)

export default component.exports